import React from 'react';
import Logo from '../../assets/images/logo.png';

const Footer = () => {
  return (
    <>
      <footer className="p-4 bg-gray-500 shadow md:px-6 md:py-8">
        <div className="sm:flex sm:items-center sm:justify-between">
          <a
            href="https://flowbite.com"
            className="flex items-center mb-4 sm:mb-0"
          >
            <img src={Logo} className="h-20 mr-3" alt="Flowbite Logo" />
          </a>
          <ul className="flex flex-wrap items-center mb-6 text-sm font-semibold text-white sm:mb-0 dark:text-gray-400">
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6 ">
                About
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="#" className="mr-4 hover:underline md:mr-6 ">
                Licensing
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Contact
              </a>
            </li>
          </ul>
        </div>
        <hr className="my-6 text-white border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span className="block text-sm font-semibold sm:text-center">
          © 2022 <a href="https://flowbite.com" className="hover:underline"></a>
          . All Rights Reserved.
        </span>
      </footer>
    </>
  );
};

export default Footer;
